var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojioneFlagForGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 1.25C11.75 1.25 4.8125 6.5 2.25 13.75H37.625C35.0625 6.5 28.125 1.25 19.9375 1.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 38.75C28.125 38.75 35.0625 33.5625 37.625 26.25H2.25C4.8125 33.5625 11.75 38.75 19.9375 38.75Z",
    fill: "#FFCF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 13.75C1.5625 15.6875 1.1875 17.8125 1.1875 20C1.1875 22.1875 1.5625 24.3125 2.25 26.25H37.625C38.3125 24.3125 38.6875 22.1875 38.6875 20C38.6875 17.8125 38.3125 15.6875 37.625 13.75H2.25Z",
    fill: "#DE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneFlagForGermany);
export default __webpack_public_path__ + "static/media/emojione_flag-for-germany.e1d5ede4b401cb1129d7780ccd286757.svg";
export { ForwardRef as ReactComponent };